module.exports = __webpack_public_path__ + "media/images/career_camp/2022/dividers/companies_mountain_1-24759213270c59fa8b59181b98bd8b0f.svg";